import * as yup from 'yup'
const regex =
  /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i

export const validationSchema = (date) =>
  yup.object({
    conductorIM: yup.object().shape(
      {
        nombre: yup
          .string()
          .nullable()
          .ensure()
          .when('rut', {
            is: (rut) => rut,
            then: yup.string().required('El campo es obligatorio.')
          }),
        email: yup.string().nullable().email('Email Invalido'),
        movil: yup
          .string()
          .nullable()
          .max(9, 'Telefono Invalido')
          .min(0, 'Telefono Invalido'),
        phone: yup
          .string()
          .nullable()
          .max(9, 'Telefono Invalido')
          .min(0, 'Telefono Invalido'),
        rut: yup
          .string()
          .ensure()
          .when('nombre', {
            is: (nombre) => nombre,
            then: yup
              .string()
              .required('El campo es obligatorio.')
              .test('rut', ' Rut Invalido ', (value) => validaRut(value))
          })
      },
      [['rut', 'nombre']]
    ),
    implicado: yup.object().shape(
      {
        nombre: yup
          .string()
          .nullable()
          .when('rut', {
            is: (rut) => rut,
            then: yup.string().required('El campo es obligatorio.'),
            otherwise: yup.string()
          }),
        email: yup.string().nullable().email('Email Invalido'),
        movil: yup
          .string()
          .nullable()
          .max(9, 'Telefono Invalido')
          .min(0, 'Telefono Invalido'),
        phone: yup
          .string()
          .nullable()
          .max(9, 'Telefono Invalido')
          .min(0, 'Telefono Invalido'),
        rut: yup
          .string()
          .ensure()
          .when('nombre', {
            is: (nombre) => nombre,
            then: yup
              .string()
              .required('El campo es obligatorio.')
              .test('rut', ' Rut Invalido ', (value) => validaRut(value))
          })
      },
      [['rut', 'nombre']]
    ),
    propietario: yup.object().shape(
      {
        nombre: yup.string().when('rut', {
          is: (rut) => rut,
          then: yup.string().required('El campo es obligatorio.'),
          otherwise: yup.string()
        }),
        email: yup.string().nullable().email('Email Invalido'),
        movil: yup
          .string()
          .nullable()
          .max(9, 'Telefono Invalido')
          .min(0, 'Telefono Invalido'),
        phone: yup
          .string()
          .nullable()
          .max(9, 'Telefono Invalido')
          .min(0, 'Telefono Invalido'),
        rut: yup
          .string()
          .ensure()
          .when('nombre', {
            is: (nombre) => nombre,
            then: yup
              .string()
              .required('El campo es obligatorio.')
              .test('rut', ' Rut Invalido ', (value) => validaRut(value))
          })
      },
      [['rut', 'nombre']]
    ),
    terceroImplicado: yup.object().shape({
      fechaSiniestroIM: yup
        .date()
        .nullable()
        .max(new Date(), 'Fecha no puede ser mayor a la fecha actual')
        .min(date, 'La fecha debe ser mayor que la Fecha de Siniestro'),
      patente: yup.string().nullable().matches(regex, 'Patente Invalida')
    })
  })

export const validationSchemaLiquidation = (date) =>
  yup.object().shape(
    {
      mdaIndemniza: yup
        .string()
        .ensure()
        .when('mtoIndemnizacion', {
          is: (mtoIndemnizacion) => mtoIndemnizacion?.length > 0,
          then: yup.string().required('El campo es obligatorio.')
        }),

      mdaPago: yup
        .string()
        .ensure()
        .when('mtoPago', {
          is: (mtoPago) => mtoPago?.length > 0,
          then: yup.string().required('El campo es obligatorio.')
        }),

      mdaProvision: yup
        .string()
        .ensure()
        .when('mtoProvision', {
          is: (mtoProvision) => mtoProvision?.length > 0,
          then: yup.string().required('El campo es obligatorio.')
        }),
      mdaSalvataje: yup
        .string()
        .ensure()
        .when('mtoSalvataje', {
          is: (mtoSalvataje) => mtoSalvataje?.length > 0,
          then: yup.string().required('El campo es obligatorio.')
        }),
      mdaCobertura: yup
        .string()
        .ensure()
        .when('mtoCobertura', {
          is: (mtoCobertura) => mtoCobertura?.length > 0,
          then: yup.string().required('El campo es obligatorio.')
        }),

      fechaInforme: yup
        .date()
        .nullable()
        .max(new Date(), 'Fecha no puede ser mayor a la fecha actual')
        .min(date, 'La fecha debe ser mayor que la Fecha de Siniestro'),

      fechaPago: yup
        .date()
        .nullable()
        .max(new Date(), 'Fecha no puede ser mayor a la fecha actual')
        .min(date, 'La fecha debe ser mayor que la Fecha de Siniestro'),

      mtoIndemnizacion: yup
        .string()
        .ensure()
        .when('mdaIndemniza', {
          is: (mdaIndemniza) => mdaIndemniza,
          then: yup.string().required('El campo es obligatorio.')
        }),
      mtoPago: yup
        .string()
        .ensure()
        .when('mdaPago', {
          is: (mdaPago) => mdaPago,
          then: yup.string().required('El campo es obligatorio.')
        }),
      mtoSalvataje: yup
        .string()
        .ensure()
        .when('mdaSalvataje', {
          is: (mdaSalvataje) => mdaSalvataje,
          then: yup.string().required('El campo es obligatorio.')
        }),
      mtoProvision: yup
        .string()
        .ensure()
        .when('mdaProvision', {
          is: (mdaProvision) => mdaProvision,
          then: yup.string().required('El campo es obligatorio.')
        }),
      mtoCobertura: yup
        .string()
        .ensure()
        .when('mdaCobertura', {
          is: (mdaCobertura) => mdaCobertura,
          then: yup.string().required('El campo es obligatorio.')
        })
    },
    [
      ['mtoIndemnizacion', 'mdaIndemniza'],
      ['mtoPago', 'mdaPago'],
      ['mtoSalvataje', 'mdaSalvataje'],
      ['mtoProvision', 'mdaProvision'],
      ['mtoCobertura', 'mdaCobertura']
    ]
  )

export const validationSchemaForm = () =>
  yup.object({
    estadoCaso: yup.string().required('El campo es obligatorio.'),

    observacion: yup
      .string()
      .ensure()
      .when('estadoCaso', {
        is: (estadoCaso) => estadoCaso === '200003',
        then: yup.string().required('El campo es obligatorio.')
      })
  })

export function validaRut(rut) {
  rut = rut.split('.').join('')
  rut = rut.split('-').join('')
  // Valor acumulado para el calculo de la formula
  var nAcumula = 0
  // Factor por el cual se debe multiplicar el valor de la posicion
  var nFactor = 2
  // Digito verificador
  var nDv = 0
  var nDvReal = 0
  // extraemos el ultimo numero o letra que corresponde al verificador
  // La K corresponde a 10
  if (rut.charAt(rut.length - 1).toUpperCase() === 'K') nDvReal = 10
  // el 0 corresponde a 11
  else if (rut.charAt(rut.length - 1) === 0) {
    nDvReal = 11
  } else nDvReal = rut.charAt(rut.length - 1)
  for (var nPos = rut.length - 2; nPos >= 0; nPos--) {
    nAcumula += rut.charAt(nPos).valueOf() * nFactor
    nFactor++
    if (nFactor > 7) nFactor = 2
  }
  nDv = 11 - (nAcumula % 11)
  if (nDv === parseFloat(nDvReal)) {
    return true
  }
  return false
}

export function formatoMonto(valor, aceptaNegativos) {
  if (aceptaNegativos == null) aceptaNegativos = false
  if (valor == null) {
    return ''
  }
  valor = valor.toString().split('.').join('')
  var cont = 0
  var formato = ''
  var regex = aceptaNegativos ? /^\-?\d*$/ : /^\d*$/

  if (valor.length === 0) {
    return ''
  } else if (valor.length > 1 /*&& regex.test(valor)*/) {
    const negativo = valor.startsWith('-')
    if (aceptaNegativos && negativo) valor = valor.substring(1)
    for (var i = valor.length - 1; i >= 0; i--) {
      formato = valor.substring(i, i + 1) + formato
      cont++
      if (formato !== ',') {
        if (cont === 3 && i !== 0) {
          formato = '.' + formato
          cont = 0
        }
      }
    }
    if (aceptaNegativos && negativo) formato = '-' + formato
    return formato
  } else {
    return regex.test(valor)
      ? valor
      : formatoMonto(valor.substring(0, valor.length - 1))
  }
}
